/**
 * Imports the BASE URL from the config.
 */
import { FH_CONFIG } from '../config.js';

/**
 * Imports the Freighthub API.
 */
import { api } from '../api';

export default {
    /**
     * GET
     */
    getContractors: function( params ){
        return api.get( '/carrier/gps/contractors/', { params: params } );
    },

    /**
     * DELETE
     */
    deleteContractor: function( contractorId ){
        return api.delete( '/carrier/gps/contractors/' + contractorId );
    },

    /**
     * POST
     */
    postContractor: function( { name } ){
        return api.post( '/carrier/gps/contractors/',
            {
                name: name,
            }
        );
    },

    /**
     * PUT
     */
    putContractor: function( { id, name } ){
        return api.put( '/carrier/gps/contractors/' + id,
            {
                name: name
            }
        );
    },
}